import * as React from "react";
import PropTypes from 'prop-types';

const SvgSearchIconNew = props => {
  if (props.id !== "_svgsearchiconnew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path d="M14.477 14.483a5.344 5.344 0 01-7.55 0 5.33 5.33 0 010-7.542 5.344 5.344 0 017.55 0 5.33 5.33 0 010 7.542zm5.663 4.4l-3.775-3.771-.041-.039a7.105 7.105 0 00-.588-9.391 7.125 7.125 0 00-10.068.002 7.107 7.107 0 00-.587 9.354 7.125 7.125 0 009.987 1.291l.038.04 3.774 3.771a.89.89 0 101.26-1.257z" fill="#202020" /></svg>;
};

SvgSearchIconNew.displayName = "_svgsearchiconnew";
SvgSearchIconNew.propTypes = {
  id: PropTypes.string
};
SvgSearchIconNew.defaultProps = {
  id: ''
};
export default SvgSearchIconNew;